














import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Statistics } from "../../models/statistics.model";
import AppStatisticsCounter from "../../components/Counter/AppStatisticsCounter.vue";

@Component({
  name: "HomeStatistics",
  components: { AppStatisticsCounter }
})
export default class HomeStatistics extends Vue {
  @Prop() statistics!: Statistics;
}
